import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';
import { Box, Link, useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import { useGetInstructionsQuery } from 'src/services/ai-instruction/aiInstructionApi';
import { Routes } from 'src/utils/enums';

export const KnowledgeCoachingLinks = ({
  instructionIds,
}: {
  instructionIds: string[];
}) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const { palette } = useTheme();
  const { data: instructions = [], isLoading } = useGetInstructionsQuery({
    draftMode: 'any',
  });

  return (
    <Box
      component='ul'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        listStyle: 'none',
        m: 0,
        p: 0,
      }}
    >
      {instructionIds.map(id => {
        const instruction = instructions.find(
          item => item.ai_instruction_id === id,
        );

        return (
          <Box component='li' key={id} sx={{ overflowWrap: 'anywhere' }}>
            {instruction?.name ? (
              <Link
                component={RouterLink}
                rel='noopener noreferrer'
                target='_blank'
                to={`${Routes.KNOWLEDGE}?aiInstruction=${encodeURIComponent(id)}`}
                variant='font12'
              >
                {instruction.name}
              </Link>
            ) : (
              <Typography color={palette.colors.grey[600]} variant='font12'>
                {isLoading
                  ? id
                  : t('common.nameValuePair', {
                      name: t('conversationAudit.absenceUnavailable'),
                      value: id,
                    })}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
};
